import React, { useState } from 'react';
import { Info } from 'lucide-react';
import { TimePeriod, PERIOD_LABELS, PERIOD_MULTIPLIERS } from '../../types';

interface PeriodConversionTooltipProps {
  dailyQuantity: number;
  currentPeriod: TimePeriod;
  darkMode: boolean;
}

const PeriodConversionTooltip: React.FC<PeriodConversionTooltipProps> = ({ dailyQuantity, currentPeriod, darkMode }) => {
  const [isOpen, setIsOpen] = useState(false);

  const conversions = {
    day: Math.round(dailyQuantity * PERIOD_MULTIPLIERS.day),
    week: Math.round(dailyQuantity * PERIOD_MULTIPLIERS.week),
    month: Math.round(dailyQuantity * PERIOD_MULTIPLIERS.month),
    year: Math.round(dailyQuantity * PERIOD_MULTIPLIERS.year)
  };

  return (
    <div className="relative inline-block">
      <button
        onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)} onClick={() => setIsOpen(!isOpen)}
        className={`p-1 rounded transition-colors ${darkMode ? 'text-appines-white/45 hover:text-appines-emerald hover:bg-appines-white/10' : 'text-appines-petrol/45 hover:text-appines-emerald hover:bg-[rgba(1,42,54,0.06)]'}`}
        title="Voir les conversions">
        <Info className="h-4 w-4" />
      </button>
      {isOpen && (
        <div className={`absolute z-50 bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-64 p-3 rounded-lg shadow-xl border ${darkMode ? 'bg-appines-petrol border-appines-white/12 text-appines-white' : 'bg-appines-white border-[rgba(1,42,54,0.12)] text-appines-black'}`}>
          <div className={`text-xs font-semibold mb-2 pb-2 border-b ${darkMode ? 'border-appines-white/12' : 'border-[rgba(1,42,54,0.12)]'}`}>Conversions de quantité</div>
          <div className="space-y-2">
            {(Object.keys(conversions) as TimePeriod[]).map((period) => (
              <div key={period} className={`flex justify-between items-center py-1 px-2 rounded ${period === currentPeriod ? 'bg-appines-glass/25 text-appines-petrol' : ''}`}>
                <span className="text-xs font-medium">{PERIOD_LABELS[period]}:</span>
                <span className={`text-xs font-semibold ${period === currentPeriod ? '' : darkMode ? 'text-appines-white/65' : 'text-appines-petrol/65'}`}>{conversions[period]} actes</span>
              </div>
            ))}
          </div>
          <div className={`mt-2 pt-2 border-t text-xs ${darkMode ? 'border-appines-white/12 text-appines-white/45' : 'border-[rgba(1,42,54,0.12)] text-appines-petrol/45'}`}>
            Base: {dailyQuantity.toFixed(2)} actes/jour
          </div>
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-px">
            <div className={`w-3 h-3 rotate-45 ${darkMode ? 'bg-appines-petrol border-r border-b border-appines-white/12' : 'bg-appines-white border-r border-b border-[rgba(1,42,54,0.12)]'}`} />
          </div>
        </div>
      )}
    </div>
  );
};

export default PeriodConversionTooltip;
